module.exports = __webpack_public_path__ + "static/news9-4-84db5d3ba2645e89a7ae769a7fefc34d.jpg";